import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ShButtonComponent } from '@seahorse/components';
import { DialogFooterComponent } from './dialog-footer.component';
import {
  AlertOptions,
  DIALOG_DATA,
  DialogContent,
  DialogRef,
} from './dialog.models';

/** The content of `DialogService.alert`. Internal. */
@Component({
  selector: 'sh-alert-dialog-content',
  changeDetection: ChangeDetectionStrategy.Default,
  imports: [NgIf, TranslateModule, ShButtonComponent, DialogFooterComponent],
  template: `
    <p class="dialog-message">{{ data.message | translate }}</p>
    <sh-dialog-footer *ngIf="showOk">
      <sh-button
        styleClass="dialog-ok"
        [autofocus]="true"
        [label]="okLabel"
        (click)="dialogRef.ok()"
      ></sh-button>
    </sh-dialog-footer>
  `,
})
export class AlertDialogContentComponent
  implements DialogContent<AlertOptions, void>
{
  readonly data = inject<AlertOptions>(DIALOG_DATA);
  readonly dialogRef = inject<DialogRef<void>>(DialogRef);
  protected readonly okLabel = this.data.okLabel ?? 'shared.terms.ok';
  protected readonly showOk = this.data.showOk ?? true;
}
